/**
 * @fileoverview WhatsNewDialogFooter — fixed footer for the WhatsNewDialog.
 * Left: SubscribeNewsletterSwitch. Right: an outlined link button
 * ("Go to all platform updates") with an `arrow-top-right` icon, plus a
 * primary outlined "Close" button. Callers can override labels, target
 * URL, and switch state without recomposing the layout.
 *
 * Foundry mapping: `release-notes__whats-new-dialog-footer__1g6dw2s` +
 * `release-notes__whats-new-dialog-footer-action-buttons__1g6dw2s`.
 */

import { AnchorButton, Button } from "@blueprintjs/core";
import type { ReactElement } from "react";
import { SubscribeNewsletterSwitch } from "../atoms/subscribe-newsletter-switch";

interface WhatsNewDialogFooterProps {
  /** Subscribe-toggle state (controlled). */
  subscribed?: boolean;
  onSubscribedChange?: (checked: boolean) => void;
  /** Link target for the secondary action. */
  allUpdatesHref?: string;
  allUpdatesLabel?: string;
  closeLabel?: string;
  onClose?: () => void;
  className?: string;
}

export function WhatsNewDialogFooter({
  subscribed,
  onSubscribedChange,
  allUpdatesHref = "/docs/foundry/announcements",
  allUpdatesLabel = "Go to all platform updates",
  closeLabel = "Close",
  onClose,
  className,
}: WhatsNewDialogFooterProps): ReactElement {
  return (
    <div data-testid="whats-new-dialog-footer" className={["bp-whats-new-dialog-footer", className].filter(Boolean).join(" ")}>
      <SubscribeNewsletterSwitch checked={subscribed} onChange={onSubscribedChange} />
      <div className="bp-whats-new-dialog-footer-action-buttons">
        <AnchorButton
          outlined
          href={allUpdatesHref}
          target="_blank"
          rel="noreferrer"
          rightIcon="arrow-top-right"
          text={allUpdatesLabel}
        />
        <Button intent="primary" outlined text={closeLabel} onClick={onClose} />
      </div>
    </div>
  );
}
